import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedAnime from './components/FeaturedAnime';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <header>
        <Navbar />
      </header>

      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedAnime />
        <LatestUpdates />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}